import { gql } from '@apollo/client';
import { registerFragment } from '@redwoodjs/web/apollo';

export const INVENTORY_TRANSFER_LOT_ROW_FRAGMENT = gql`
  fragment InventoryTransferLotRowFragment on Lot {
    id
    slug
    quantity
    warehouseId
    weightPerInventoryUnit
    metrics {
      unitsAvailable
    }
    product {
      id
      description
      weightPerInventoryUnit
      cartonsPerPallet
      commodity {
        name
      }
    }
    transferredChildren {
      slug
      warehouseId
    }
  }
`;

registerFragment(INVENTORY_TRANSFER_LOT_ROW_FRAGMENT);
